import { Link } from "react-router-dom";
import { Instagram, MessageCircle } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { igLink, useCatalog, waLink } from "@/lib/site";

const LINKS = [
  { to: "/politicas/privacidad", label: "Privacidad", id: "privacidad" },
  { to: "/politicas/terminos", label: "Términos", id: "terminos" },
  { to: "/politicas/envios", label: "Envíos", id: "envios" },
  { to: "/como-funciona#guia", label: "Guía de instalación", id: "guia" },
];

export const SiteFooter = () => {
  const { data } = useCatalog();
  const c = data?.contact;
  return (
    <footer className="border-t border-[#EAE7E2] bg-[#FAF8F4]">
      <div className="mx-auto grid max-w-[1400px] gap-10 px-5 sm:px-8 lg:px-12 py-14 md:grid-cols-[auto_1fr_auto] md:items-center">
        <Logo size={88} />
        <nav aria-label="Enlaces legales" className="flex flex-wrap gap-x-8 gap-y-3 md:justify-center">
          {LINKS.map((l) => <Link key={l.to} to={l.to} data-testid={`footer-link-${l.id}`} className="text-sm text-[#080808]/70 hover:text-[#080808] transition-colors">{l.label}</Link>)}
        </nav>
        {c && (
          <div className="flex flex-col gap-3 text-sm">
            <a href={waLink(c.whatsapp)} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 text-[#080808] hover:text-[#B18A4B] transition-colors"><MessageCircle className="h-4 w-4" /> {c.whatsapp}</a>
            <a href={igLink(c.instagram)} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-2 text-[#080808] hover:text-[#B18A4B] transition-colors"><Instagram className="h-4 w-4" /> @{c.instagram}</a>
          </div>
        )}
      </div>
      <div className="border-t border-[#EAE7E2] px-5 py-6 text-center text-xs text-[#080808]/55">
        © {new Date().getFullYear()} LUMINA STUDIO · {c?.shipping_origin || "Colombia"}
      </div>
    </footer>
  );
};
